import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW6700Model } from './kymw6700.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { CommonSetting } from '../../../../../src/app/commons/kymw00/common-setting';
import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';
import { GetProofListService } from './api-services/get-proof-list.service';
import { CodeComboBoxComponent } from '../../../commons/kymw02/combo-box/code-combo-box/code-combo-box.component';
// eslint-disable-next-line max-len
import { CatalogProgressTextInputComponent } from '../../../commons/kymw02/text-input/catalog-progress-text-input/catalog-progress-text-input.component';

/**
 * 校正紙画面を管理するクラス
 *
 * @export KYMW6700Component
 * @class KYMW6700Component
 */
@Component({
  selector: 'app-kymw6700',
  templateUrl: 'kymw6700.component.html',
  styleUrls: ['kymw6700.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW6700Component extends PlessViewHelperSub implements OnInit {

  @ViewChild('txti_OrderCode', { static: true }) public txti_OrderCode: CatalogProgressTextInputComponent;
  @ViewChild('txta_PCodeList', { static: true }) txta_PCodeList: ElementRef;
  @ViewChild('cmb_SortDiv1', { static: true }) cmb_SortDiv1: CodeComboBoxComponent;
  @ViewChild('cmb_SortDiv2', { static: true }) cmb_SortDiv2: CodeComboBoxComponent;
  @ViewChild('cmb_SortDiv3', { static: true }) cmb_SortDiv3: CodeComboBoxComponent;

  // 親画面からの連携値
  param: any;

  KYMW6700Model: KYMW6700Model = new KYMW6700Model();

  /**
   * Creates an instance of KYMW6700Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @param {FileDownloadConfirmService} fileDownloadConfirmService
   * @param {GetProofListService} getProofListService
   * @memberof KYMW6700Component
   */
  constructor(
    public dialogService: PlessDialogServiceSub,
    public kymw00Model: KYMW00Model,
    public elementRef: ElementRef,
    public fileDownloadConfirmService: FileDownloadConfirmService,
    public getProofListService: GetProofListService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof PhaseRegistComponent
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW6700';
    document.getElementById('txta_PCodeList').addEventListener('input', () => this.eventPCodeListHandler());
    this.initKYMW6700();
  }

  /**
   * 出力区分ラジオボタンを選択変更した時に呼び出されるメソッド。
   *
   * @param event コールバック・イベントへの参照
   */
  public eventOutputDivHandler(event: Event): void {
    // 選択値のチェック
    if (this.KYMW6700Model.outputDiv === this.KYMW6700Model.OUTPUT_DIV_LOGISTICS) {  // 「3:見切り品」の場合
      // フェーズコンボボックスの選択内容の変更
      this.KYMW6700Model.progressWorkNum = '*';                                 // 「*:最新情報」

      // 活性制御
      this.KYMW6700Model.disabledPhaseToFlg = true;                             // フェーズコンボボックスを非活性
      this.KYMW6700Model.disabledBuyerToFlg = true;                             // バイヤーコードを非活性
      this.KYMW6700Model.disabledMediumToFlg = true;                            // 媒体を非活性
    } else {                                                                    // 上記以外の場合
      // 活性制御
      this.KYMW6700Model.disabledPhaseToFlg = false;                            // フェーズコンボボックスを活性
      this.KYMW6700Model.disabledBuyerToFlg = false;                            // バイヤーコードを活性
      this.KYMW6700Model.disabledMediumToFlg = false;                           // 媒体を活性
    }
  }

  /**
   * Ｐコードリストに入力した時に呼び出されるメソッド。
   *
   * @param event コールバック・イベントへの参照
   */
  public eventPCodeListHandler(): void {
    const ary: Array<any> = PlessViewUtilsSub.formatList(this.KYMW6700Model.pCodeList.split('\n'), 100);
    this.KYMW6700Model.pCodeList = PlessViewUtilsSub.arrayToString(ary, '\n');
  }

  /**
   * 出力ボタンを押下した時に呼び出されるメソッド。
   *
   * @param event コールバック・イベントへの参照
   */
  public eventListOut_CLICKHandler(): void {
    if (!this.inputCheck()) {
      return;
    }

    const vo = {
      outputDiv: '',                                                              // 出力区分
      orderCode: '',                                                              // 受注コード
      mediumType: '',                                                             // 媒体区分
      progressWorkNum: '',                                                        // 工程管理NO
      classCode: '',                                                              // 部門コード
      buyerCode: '',                                                              // バイヤーコード
      sortItem1: '',                                                              // ソート項目(第１キー)
      sortItem2: '',                                                              // ソート項目(第２キー)
      sortItem3: '',                                                              // ソート項目(第３キー)
      pCodeList: [],                                                              // Ｐコードリスト
    };

    // 検索条件のVOセット
    // 出力区分
    vo.outputDiv = this.KYMW6700Model.outputDiv;

    // 受注コード
    vo.orderCode = this.KYMW6700Model.orderCode;

    if (this.KYMW6700Model.OUTPUT_DIV_LOGISTICS === vo.outputDiv) {             // 出力区分が「3：見切り品」の場合
      // 媒体区分に「028：見切り品」を設定
      vo.mediumType = this.KYMW6700Model.ADMIN_DIV_LOGISTICS;
    } else {                                                                    // 上記以外の場合
      // 媒体区分にコンボボックスの値を設定
      vo.mediumType = PlessViewUtilsSub.nullToBlank(this.KYMW6700Model.mediumType);
    }

    // 工程管理NO
    vo.progressWorkNum = PlessViewUtilsSub.nullToBlank(this.KYMW6700Model.progressWorkNum);

    // 部門コード
    vo.classCode = PlessViewUtilsSub.nullToBlank(this.KYMW6700Model.classCode);

    // バイヤーコード
    vo.buyerCode = PlessViewUtilsSub.nullToBlank(this.KYMW6700Model.buyerCode);

    // Ｐコードリスト
    vo.pCodeList = PlessViewUtilsSub.trim(this.KYMW6700Model.pCodeList).split('\n');

    // ソート項目
    vo.sortItem1 = PlessViewUtilsSub.nullToBlank(this.cmb_SortDiv1.reserve1);
    vo.sortItem2 = PlessViewUtilsSub.nullToBlank(this.cmb_SortDiv2.reserve1);
    vo.sortItem3 = PlessViewUtilsSub.nullToBlank(this.cmb_SortDiv3.reserve1);

    // API呼び出し
    this.getProofListService.execute(this.KYMW6700Model, vo, (data: any) => {

      // ファイル名の設定
      const localfile: string = data.FileName.substring(data.FileName.indexOf('Proof_'), data.FileName.length);

      this.fileDownloadConfirmService.show(data.FileName, localfile);
    });
  }

  /**
   * 画面情報の初期化
   */
  private initKYMW6700(): void {
    // 初期表示
    this.KYMW6700Model.outputDiv = this.KYMW6700Model.OUTPUT_DIV_BUYER;         // 出力区分(バイヤー・編集)ラジオボタン

    // 受注コードをクリアに連動して、配達企画回（翌週）・媒体がクリアされる
    this.KYMW6700Model.orderCode = '';

    // 媒体区分コンボボックスのデフォルト選択(環境設定管理TBLより取得)
    this.KYMW6700Model.mediumType = CommonSetting.getVal('DefProofMedium');

    // 「*:最新情報」
    this.KYMW6700Model.progressWorkNum = '*';

    // 活性制御
    this.KYMW6700Model.disabledPhaseToFlg = false;                              // フェーズコンボボックスを活性
  }

  /**
   * 入力チェック
   *
   * @return true:OK false:NG
   */
  private inputCheck(): boolean {
    // 受注コード・必須チェック
    if (PlessViewUtilsSub.isEmpty(this.KYMW6700Model.orderCode)) {
      this.dialogService.openAlertGetMessage('E0110', ['受注コード']);
      return false;
    }

    // 受注コード・存在チェック
    if (PlessViewUtilsSub.isEmpty(this.txti_OrderCode.selectedCatalogID)) {
      this.dialogService.openAlertGetMessage('E0122', ['受注コード']);
      return false;
    }

    // 媒体区分・必須チェック
    if (PlessViewUtilsSub.isEmpty(this.KYMW6700Model.mediumType)) {
      this.dialogService.openAlertGetMessage('E0209', ['媒体']);
      return false;
    }

    // フェーズ・必須チェック
    if (PlessViewUtilsSub.isEmpty(this.KYMW6700Model.progressWorkNum)) {
      this.dialogService.openAlertGetMessage('E0209', ['フェーズ']);
      return false;
    }
    return true;
  }
}
